var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',[_vm._v(_vm._s(_vm.$t('menu.invoices')))]),_c('invoices-table',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('create-button',{attrs:{"route-name":_vm.routeType.INVOICES_CREATE}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }